import { z } from 'zod';

export const TOSVersion = z.union([
  z.literal(1), // Original
  z.literal(2), // With Repay
]);

export type TOSVersion = z.infer<typeof TOSVersion>;
